import React, { useEffect } from 'react';
import ScrollTrigger from 'gsap/ScrollTrigger';
import HelmetComponent from 'components/shared/HelmetComponent';
import dictData from 'dictionary';
import HomeBanner from 'components/pages/home/HomeBanner';
import HomeInternetDelivery from 'components/pages/home/HomeInternetDelivery';
import HomeItSzkola from 'components/pages/home/HomeItSzkola';
// import HomeMleg from 'components/pages/home/HomeMleg';
import HomeMojeOse from 'components/pages/home/HomeMojeOse';
import HomeSectionHero from './HomeSectionHero';

const Home: React.FC = () => {
  // perform initial refresh after render
  useEffect(() => {
    ScrollTrigger.refresh(true);

    return () => {
      const currentScrollTriggerInstances = ScrollTrigger.getAll();
      currentScrollTriggerInstances.forEach((instance) => instance.kill()); // kill all ScrollTrigger instances on unmount
      ScrollTrigger.clearMatchMedia();
    };
  }, []);

  return (
    <>
      <HelmetComponent title={dictData.helmet.home_title} />
      <HomeBanner />
      <HomeInternetDelivery />
      <HomeItSzkola />
      {/*<HomeMleg />*/}
      <HomeSectionHero />
      <HomeMojeOse />
    </>
  );
};

export default Home;
